import { forwardRef } from 'react'
import * as ROUTES from 'Routes'
import { Field } from 'formik'
import MaskedInput from 'react-text-mask'
import Icon from 'components/Icon'
import If from '@mobi/components/If'
import { useValidate } from '../hooks'
import analytics from '@mobi/libraries/analytics'
import { formIdRegister } from 'utils/trackings/constants'

const InputText = forwardRef(
  (
    {
      name = '',
      placeholder = '',
      label = '',
      mask = () => false,
      rules,
      errors = {},
      type = 'text',
      touched,
      handleChange,
      handleBlur,
      icon,
      inputMode,
      dataTest,
      dataUnique,
      trackingFieldtype,
      trackingFieldlabel,
      errorColor,
      ...props
    },
    ref
  ) => {
    const fieldId = `field-${name}`

    const validate = useValidate(rules)

    const handleOnBlur = (event) => {
      handleBlur(event)

      const fieldInputtedPayload = {
        formId: formIdRegister,
        fieldLabel: event.currentTarget.dataset.trackingFieldlabel,
        fieldId: event.currentTarget.dataset.unique,
        fieldName: event.currentTarget.name,
        fieldType: event.currentTarget.dataset.trackingFieldtype,
      }

      if (ROUTES.register.path === window.location.pathname) {
        analytics.track('fieldInputted', fieldInputtedPayload)
      }
    }

    return (
      <div className="input-container">
        <label className="label" htmlFor={fieldId}>
          {label}
        </label>
        <Field name={name} validate={validate}>
          {({ field }) => {
            const inputProps = {
              ...field,
              className: 'input',
              id: fieldId,
              placeholder: placeholder,
              type: type,
              onChange: handleChange,
              onBlur: handleOnBlur,
              inputMode: inputMode,
              'data-test': dataTest,
              'data-unique': dataUnique,
              'data-tracking-fieldtype': trackingFieldtype,
              'data-tracking-fieldlabel': trackingFieldlabel,
              ...props,
            }

            return (
              <div className="input-content">
                {icon && (
                  <div className="icon-content">
                    <Icon iconId={icon} />
                  </div>
                )}
                <MaskedInput
                  {...inputProps}
                  mask={mask}
                  guide={false}
                  ref={ref}
                />
              </div>
            )
          }}
        </Field>
        <If
          condition={errors[name] && touched[name]}
          renderIf={
            <div
              className="error-default"
              data-test="input-error-message"
              aria-live="polite"
              aria-label={`${errors[name]} - ${label}`}
              role="alert"
            >
              <span
                className="text"
                aria-hidden={true}
                style={errorColor ? { color: errorColor } : null}
              >
                {errors[name]}
              </span>
            </div>
          }
        />
      </div>
    )
  }
)

InputText.displayName = 'InputText'

export default InputText
